import Loadable from 'react-loadable';

import { Loading } from '../../common/navigation';

const Pages = Loadable({
  loader: () => import('./components/pages'),
  loading: Loading,
});

export const routes = [
  {
    path: '/places/:slug',
    exact: true,
    name: 'Pages',
    component: Pages,
  },
  {
    path: '/places/:slug/:pageSlug',
    exact: true,
    name: 'Page',
    component: Pages,
  },
];
export * from './components';
